import PropTypes from 'prop-types';

export const WizardStepPropType = PropTypes.shape({
  overviewRow: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    button: PropTypes.shape({
      title: PropTypes.string
    })
  }),
  render: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  path: PropTypes.string
});
